import { ArticleTypeKorean } from '@/lib/utils.type';
import { ArticleType } from '@/services/types/article.type';
import { MenuItem } from '@/services/types/globals.type';
import {
  StoreDomainConfigEntity,
  StoreType,
} from '@/services/types/store.type';
import { BreadcrumbItemType } from '@/types/breadcrumb-item.type';

export const DefaultCallNumber = '1522-7730';
export const DefaultSiteName = '드라이빙존 운전면허';
export const DefaultTitle =
  DefaultSiteName + ' | 실내에서 취득하는 빠르고 안전한 운전면허';

export const DefaultDescription =
  '면허 취득을 준비중이신가요? 2종 보통부터 1종 보통, 대형 면허까지! 실내운전연습장 ' +
  DefaultSiteName +
  '에서 시뮬레이터로 안전하게 연습하고 빠르게 면허 취득하세요.';

export const DefaultKeywords =
  DefaultSiteName +
  ',드라이빙존,1종 보통,2종 보통,1종 보통 자동,1종 보통 수동,2종 보통 자동,2종 보통 수동,운전학원,운전전문학원,운전면허시험장,면허시험장,시뮬레이터,실내운전,실내운전연습장,연습면허,면허취득,장내기능,장내기능 시험,도로주행 시험,연습 면허,면허 따는 법,빠른 면허,운전 시뮬레이터, 시뮬레이터 운전,초보운전,장롱면허,운전연습,고수의운전면허,맹드라이브,운전선생';

export const DefaultImage = 'https://www.drivingzone.co.kr/ogimg.png';

/**
 * 자매 사이트(운전연수) 루트 URL.
 *
 * 같은 지점을 면허취득(이 사이트)과 운전연수(dztraining)가 각각 다뤄서, 두 상세 페이지가
 * 주소·전화·좌표가 완전히 같은 업체 노드를 따로 신고하게 된다. 검색엔진은 이를 한 개체로
 * 병합하려다 어느 쪽이 대표인지 몰라 두 사이트가 서로의 지역 검색 순위를 잠식한다.
 * 구조화 데이터의 `sameAs`로 서로를 가리켜 같은 개체임을 명시한다.
 *
 * 두 사이트의 지점 경로(`/branch/{slug}`)는 완전히 대칭이다(29곳 전부 양쪽에 존재).
 */
export const SiblingTrainingSiteUrl = 'https://www.dztraining.co.kr';

export const HomeBreadcrumbItem: BreadcrumbItemType = {
  label: '홈',
  href: '/',
};

export const AboutUsBreadcrumbItem: BreadcrumbItemType = {
  label: '드라이빙존은?',
  href: '/about-us',
};
export const BrandStoryBreadcrumbItem: BreadcrumbItemType = {
  label: '브랜드 소개',
  href: AboutUsBreadcrumbItem.href + '/brandstory',
};
export const CurriculumBreadcrumbItem: BreadcrumbItemType = {
  label: '커리큘럼',
  href: AboutUsBreadcrumbItem.href + '/curriculum',
};

export const RecommendClassBreadcrumbItem: BreadcrumbItemType = {
  label: '추천 클래스',
  href: '/recommend-class',
};

export const Unlimited2WeeksClassBreadcrumbItem: BreadcrumbItemType = {
  label: '2주완성 면허취득',
  href: RecommendClassBreadcrumbItem.href + '/unlimited-2weeks',
};
export const ParkingClassBreadcrumbItem: BreadcrumbItemType = {
  label: '주차 완전 정복',
  href: RecommendClassBreadcrumbItem.href + '/parking',
};
export const BeginnerClassBreadcrumbItem: BreadcrumbItemType = {
  label: '장롱면허 탈출',
  href: RecommendClassBreadcrumbItem.href + '/beginner',
};
export const WeekendPassClassBreadcrumbItem: BreadcrumbItemType = {
  label: '주말패스',
  href: RecommendClassBreadcrumbItem.href + '/weekend-pass',
};
export const Hour10LimitedClassBreadcrumbItem: BreadcrumbItemType = {
  label: '10시간 단기속성',
  href: RecommendClassBreadcrumbItem.href + '/hour10-limited',
};

export const PricingBreadcrumbItem: BreadcrumbItemType = {
  label: '요금안내',
  href: '/pricing',
};

export const ExamBreadcrumbItem: BreadcrumbItemType = {
  label: '시험안내',
  href: '/exam',
};
export const ExamProcessBreadcrumbItem: BreadcrumbItemType = {
  label: '면허 취득 절차',
  href: ExamBreadcrumbItem.href + '/process',
};
export const ExamTheoryBreadcrumbItem: BreadcrumbItemType = {
  label: '학과시험',
  href: ExamBreadcrumbItem.href + '/theory',
};
export const ExamSkillBreadcrumbItem: BreadcrumbItemType = {
  label: '장내기능시험',
  href: ExamBreadcrumbItem.href + '/skill',
};
export const ExamRoadBreadcrumbItem: BreadcrumbItemType = {
  label: '도로주행시험',
  href: ExamBreadcrumbItem.href + '/road',
};
export const LicenseTestCourseBreadcrumbItem: BreadcrumbItemType = {
  label: '전국 시험장 안내',
  href: ExamBreadcrumbItem.href + '/license-test-course',
};

export const BranchBreadcrumbItem: BreadcrumbItemType = {
  label: '지점안내',
  href: '/branch',
};

export const AcademyBreadcrumbItem: BreadcrumbItemType = {
  label: '학원 찾기',
  href: '/academy',
};

export const FranchiseBreadcrumbItem: BreadcrumbItemType = {
  label: '가맹문의',
  href: '/franchise',
};
export const PrivacyBreadcrumbItem: BreadcrumbItemType = {
  label: '개인정보처리방침',
  href: '/privacy',
};

export const SupportCenterBreadcrumbItem: BreadcrumbItemType = {
  label: '고객센터',
  href: '/support',
};
export const ContactBreadcrumbItem: BreadcrumbItemType = {
  label: '공지사항',
  href: SupportCenterBreadcrumbItem.href + '/contact',
};
export const FaqBreadcrumbItem: BreadcrumbItemType = {
  label: 'FAQ',
  href: SupportCenterBreadcrumbItem.href + '/faq',
};
export const EventBreadcrumbItem: BreadcrumbItemType = {
  label: ArticleTypeKorean[ArticleType.EVENT],
  href: '/event',
};
export const AboutUsBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  BrandStoryBreadcrumbItem,
  CurriculumBreadcrumbItem,
];
export const ContactBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  SupportCenterBreadcrumbItem,
  ContactBreadcrumbItem,
];
export const FaqBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  SupportCenterBreadcrumbItem,
  FaqBreadcrumbItem,
];
export const EventBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  EventBreadcrumbItem,
];
export const RecommendClassBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  RecommendClassBreadcrumbItem,
];

export const StoryBreadcrumbItem: BreadcrumbItemType = {
  label: ArticleTypeKorean[ArticleType.STORY],
  href: '/story',
};
export const BlogBreadcrumbItem: BreadcrumbItemType = {
  label: ArticleTypeKorean[ArticleType.BLOG],
  href: StoryBreadcrumbItem.href + '/blog',
};
export const LicenseProcessBreadcrumbItem: BreadcrumbItemType = {
  label: ArticleTypeKorean[ArticleType.LICENSE_PROCESS],
  href: StoryBreadcrumbItem.href + '/license-process',
};
export const TestCourseAnalysisBreadcrumbItem: BreadcrumbItemType = {
  label: ArticleTypeKorean[ArticleType.TEST_COURSE_ANALYSIS],
  href: StoryBreadcrumbItem.href + '/test-course-analysis',
};
export const StoryBreadcrumbItems: BreadcrumbItemType[] = [
  HomeBreadcrumbItem,
  StoryBreadcrumbItem,
];

export const BlogBreadcrumbItems: BreadcrumbItemType[] = [
  ...StoryBreadcrumbItems,
  BlogBreadcrumbItem,
];
export const LicenseProcessBreadcrumbItems: BreadcrumbItemType[] = [
  ...StoryBreadcrumbItems,
  LicenseProcessBreadcrumbItem,
];

export const TestCourseAnalysisBreadcrumbItems: BreadcrumbItemType[] = [
  ...StoryBreadcrumbItems,
  TestCourseAnalysisBreadcrumbItem,
];

export const menuItems: MenuItem[] = [
  {
    ...AboutUsBreadcrumbItem,
    parentHref: AboutUsBreadcrumbItem.href,
    submenu: [BrandStoryBreadcrumbItem, CurriculumBreadcrumbItem],
  },
  {
    ...RecommendClassBreadcrumbItem,
    parentHref: RecommendClassBreadcrumbItem.href,
    submenu: [
      Unlimited2WeeksClassBreadcrumbItem,
      ParkingClassBreadcrumbItem,
      BeginnerClassBreadcrumbItem,
      WeekendPassClassBreadcrumbItem,
      Hour10LimitedClassBreadcrumbItem,
    ],
  },
  PricingBreadcrumbItem,
  {
    ...ExamBreadcrumbItem,
    parentHref: ExamBreadcrumbItem.href,
    submenu: [
      ExamProcessBreadcrumbItem,
      ExamTheoryBreadcrumbItem,
      ExamSkillBreadcrumbItem,
      ExamRoadBreadcrumbItem,
      LicenseTestCourseBreadcrumbItem,
    ],
  },
  BranchBreadcrumbItem,
  {
    ...StoryBreadcrumbItem,
    parentHref: StoryBreadcrumbItem.href,
    submenu: [
      BlogBreadcrumbItem,
      LicenseProcessBreadcrumbItem,
      TestCourseAnalysisBreadcrumbItem,
    ],
  },
  EventBreadcrumbItem,
  {
    ...SupportCenterBreadcrumbItem,
    parentHref: SupportCenterBreadcrumbItem.href,
    submenu: [ContactBreadcrumbItem, FaqBreadcrumbItem],
  },
];

export const defaultStoreDomainConfig: StoreDomainConfigEntity = {
  storeId: 0,
  name: '(주)드라이빙존 운전면허',
  type: StoreType.DIRECT,
  phoneNumber: '1522-7730',
  ownerName: '이영은',
  roadAddress: '서울특별시 강남구 테헤란로114길 26 두원빌딩 2층, 202호',
  businessRegistrationNumber: '486-88-00482',
  businessRegistrationName: '(주)드라이빙존 운전면허',
  email: 'help@drivingzone.co.kr',
  logoUrl: '/images/logo.webp',
  instagram: 'https://www.instagram.com/drivingzone_official/',
  blog: 'https://blog.naver.com/drivingzone0509',
  youtube: 'https://www.youtube.com/channel/UCJF1icrhWYSNtIC4jciiYVQ',
  province: null,
  district: null,
} as StoreDomainConfigEntity;

export interface MainVideoEntity {
  label: string;
  videoPoster: string;
  videoUrl: string;
}
